'use client'
import { Button as ChakraButton } from '@chakra-ui/react'
import { forwardRef, HTMLProps, LegacyRef } from 'react'

import { ButtonLinkProps } from './ButtonLink.types'

export default forwardRef(function ButtonLink(
  props: ButtonLinkProps,
  ref: LegacyRef<HTMLButtonElement & HTMLProps<HTMLAnchorElement>>
) {
  return <ChakraButton {...props} ref={ref} as="a" translate="no" />
})
